import { Container, Typography, Box, Divider } from "@mui/material";
import { Helmet } from "react-helmet-async";

function Disclaimer() {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Helmet>
        <title>Disclaimer — Loops</title>
        <meta name="description" content="Read the Loops disclaimer. Deal availability and pricing may vary — always verify with the restaurant directly." />
        <link rel="canonical" href="https://loopsfood.com/disclaimer" />
      </Helmet>
      <Typography
        variant="h3"
        sx={{ fontWeight: 500, mb: 2, textAlign: "center" }}
      >
        Disclaimer
      </Typography>

      <Typography
        variant="body1"
        sx={{ color: "#6b7280", mb: 6, textAlign: "center" }}
      >
        Last updated: October 7, 2025
      </Typography>

      <Divider sx={{ mb: 6 }} />

      <Box sx={{ "& p": { mb: 2, lineHeight: 1.7 } }}>
        <Typography variant="body1">
          Loops is an independent platform that aggregates publicly available
          restaurant promotions and set lunch deals for informational purposes
          only. All restaurant names, logos, trademarks, and promotional
          materials belong to their respective owners. Loops is not affiliated
          with, endorsed by, or officially partnered with the restaurants
          listed, unless expressly stated. Deal information is subject to change
          by the restaurant without notice — please verify details directly with
          the restaurant before visiting.
        </Typography>
      </Box>
    </Container>
  );
}

export default Disclaimer;
